import {
  Component,
  OnInit,
  OnDestroy,
  Renderer2,
  AfterViewInit,
  ViewChildren,
  QueryList,
  ElementRef,
  HostListener,
  ViewChild,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { IAppState } from "src/app/store/states/app";
import { Subscription, combineLatest } from "rxjs";
import {
  selectIsAuthenticated,
  selectManageOwnAuctions,
  selectAuthenticatedAdmin,
  selectAuthenticatedUserMe,
  selectIsAuthenticating,
} from "src/app/store/selectors";
import { FormBuilder } from "@angular/forms";
import { Logout } from "src/app/store/actions/user";
import { ApiService } from "src/app/services/api/api.service";
import { TNetService } from "src/app/services/tNet.service";
import { ModalService } from "../../modules/modal/services/modal.service";
import { CookieService } from "src/app/services/cookie.service";

const balanceType = {
  in: 1,
  out: 2,
};

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren("navbarDropdownItem") navbarDropdownItem: QueryList<any>;
  @ViewChild("navDropdownButton") navDropdownButton: ElementRef;
  @ViewChild("burgerMenu") burgerMenu: ElementRef;
  @ViewChild("toggleButton") toggleButton: ElementRef;

  public tnetDropDown: boolean = false;
  public tNetLogoColored: boolean = false;
  private elementRef: ElementRef;

  private selectIsAuthenticated: boolean;
  private selectIsAuthenticatedSubscription: Subscription;
  private canManageAuction: boolean;
  private balance;
  private isAdmin;

  public headerSupNavLinks = [
    {
      title: "უძრავი ქონება",
      url: "https://livo.ge",
    },
    {
      title: "ინტერიერის დიზაინერები",
      url: "https://interior.livo.ge",
    },
    {
      title: "დეველოპერები",
      url: "https://livo.ge/developerebi",
    },
    {
      title: "3D გადაღება",
      url: "https://livo.ge/3d-turi",
    },
    {
      title: "ფოტოგადაღება",
      url: "https://livo.ge/photo-tour",
    },
    // {
    //   title: 'იპოთეკური სესხი',
    //   url: 'https://livo.ge/?take_loan=true'
    // },
    // {
    //   title: 'ფასის დადგენა',
    //   url: 'https://livo.ge/?ai_modal=true'
    // }
  ];

  public navbar: boolean = false;

  constructor(
    private apiService: ApiService,
    private cookieServices: CookieService,
    private tnetService: TNetService,
    private store: Store<IAppState>,
    private formBuidler: FormBuilder,
    elementRef: ElementRef,
    private modalService: ModalService,
  ) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    this.selectIsAuthenticatedSubscription = combineLatest(
      this.store.select(selectIsAuthenticating),
      this.store.select(selectIsAuthenticated),
      this.store.select(selectAuthenticatedUserMe),
      this.store.select(selectManageOwnAuctions),
      this.store.select(selectAuthenticatedAdmin),
    ).subscribe(
      ([authenticating, authenticated, user, canManageAuction, admin]) => {
        this.selectIsAuthenticated = authenticated;
        if (!authenticating && authenticated) {
          this.canManageAuction = canManageAuction;
          this.isAdmin = admin;
          if (user) {
            this.balance = user.balance;
          }
        }
      },
    );
  }

  @HostListener("document:click", ["$event"])
  onClick(event: any) {
    if (
      this.elementRef.nativeElement.contains(event.target) ||
      !event.target.classList.contains("tnet-logo")
    ) {
      this.tnetModalShowfunc(false);
    }
  }

  ngAfterViewInit() {
    if (!this.isHeaderBannerClosed) {
      setTimeout(() => {
        //@ts-ignore
        window.ado.refresh(
          "ado-6a2hNgFSzE498oFHKPX7Zu45zTjhpidCqdX47K8THXL.N7",
        );
      }, 0);
      // [style]="isHeaderBannerClosed ? 'display: none' : ''"
    }

    // in case to close burger menu on item click
    // this.renderer.listen('window', 'click', (e) => {
    //   // const navElement = document.getElementById('navbarNavDropdown');
    //   // if (!this.navbarDropdownItem.some(item => item.nativeElement === e.target) && navElement && navElement.classList.contains('show')) {
    //   //   this.navDropdownButton.nativeElement.click()
    //   // }
    //   if (!e.target.className.includes('burger-menu-content') && this.burgerMenu.nativeElement.classList.contains('show')) {
    //     this.navDropdownButton.nativeElement.click();
    //   }
    // });
  }

  handleCloseHeaderBanner() {
    this.cookieServices.setCookieWithMinutes("header-banner", "hidden", 15);
  }

  openModal(name: string) {
    this.modalService.load({ name });
  }

  tnetModalShowfunc(data) {
    this.tnetDropDown = data;
    this.tnetService.setTnetCompaniesModal(data);
  }

  tnetLogoHovered(val) {
    this.tNetLogoColored = val;
  }

  logout() {
    this.store.dispatch(new Logout({}));
  }

  get isHeaderBannerClosed() {
    return this.cookieServices.getCookie("header-banner") == "hidden";
  }

  get isUserAuthenticated() {
    return this.selectIsAuthenticated;
  }

  get userCanManageAuctions() {
    return this.canManageAuction;
  }

  get getBalance() {
    return this.balance;
  }

  get getIsAdmin() {
    return this.isAdmin;
  }

  ngOnDestroy() {
    this.selectIsAuthenticatedSubscription.unsubscribe();
  }
}
